import React from 'react';
import Layout from 'layout/Layout';
import PreviewingReservationConfirmComponent from 'components/PreviewingReservationConfirmComponent';

const PreviewingReservationConfirmPage: React.FC = () => {
  const pageTitle = '予約確認';

  return (
    <Layout pageTitle={pageTitle}>
      <PreviewingReservationConfirmComponent></PreviewingReservationConfirmComponent>
    </Layout>
  );
};
export default PreviewingReservationConfirmPage;
